import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { CalendarRange, ListFilter, Plus, SquareKanban } from "lucide-react";

export default function KanbanFilters({
  renderFilters,
  renderNewButton,
  calendarSwitched,
  onCalendarSwitchClicked,
}) {
  return (
    <div className="px-8 py-2 flex items-center justify-between mb-4 gap-4 bg-background">
      <div className="flex items-center gap-4">
        <span className="flex items-center gap-1 text-sm text-muted-foreground">
          <SquareKanban className="text-foreground h-4 w-4" />
          Board
        </span>
        <Switch checked={calendarSwitched} onClick={onCalendarSwitchClicked} />
        <span className="flex items-center gap-1 text-sm text-muted-foreground">
          <CalendarRange className="text-foreground h-4 w-4" />
          Calendar
        </span>
      </div>
      <div className="flex items-center gap-4">
        {/* <div className="grid grid-cols-[auto_1fr_1fr] grid-rows-[2rem] items-center border rounded-md"> */}
        <div className="flex h-9 items-center border rounded-md">
          <span className="flex items-center gap-1 text-muted-foreground bg-muted/50 h-full px-2">
            <ListFilter className="h-4 w-4" />
            Filters
          </span>
          {renderFilters && renderFilters()}
        </div>
        {renderNewButton && renderNewButton()}
      </div>
    </div>
  );
}
